module.exports = __webpack_public_path__ + "img/22.problem_blockage.3e72ef70.svg";